<template>
<div>
  <el-dialog title="广告编辑" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false" width="800px">
    <el-form size="small" :model="form" ref="form">
      <div class="common-form">基本信息</div>
      <el-form-item label="广告位" :label-width="formLabelWidth" >
         <span>{{form.adv.name}}</span>
      </el-form-item>
      <el-form-item label="广告图片"  :label-width="formLabelWidth" :rules="[{required: true,message: '请选择'}]">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div class="d-c-c ad-picture" v-if='form.adv_img'>
            <a target="_blank" title="点击查看大图" :href="form.adv_img">
              <img  :src="form.adv_img" width="300" height="124" />
            </a>
          </div>
          <div v-else>未上传</div>
        </el-row>
      </el-form-item>
        <el-form-item label="链接" :label-width="formLabelWidth" prop="adv_link" :rules="[{required: true,message: '请选择链接'}]">
          <div class="d-s-c">
            <el-input v-model="form.adv_link"></el-input>

            <el-button type="primary" @click="changeLink()">选择链接</el-button>
          </div>
        </el-form-item>
      <el-form-item label="购买时长（天）" :label-width="formLabelWidth" :rules="[{required: true,message: '请设置时长'}]">
        <el-input-number v-model="form.days" :min="1" :max='30' ></el-input-number>
      </el-form-item>
      <el-form-item label="广告状态" :label-width="formLabelWidth">
        <el-radio-group v-model="form.status" v-if="form.status<4">
          <el-radio :label="0">待提交</el-radio>
          <el-radio :label="2">审核中</el-radio>
          <el-radio :label="3">通过</el-radio>
          <el-radio :label="1">拒绝</el-radio>
        </el-radio-group>
        <span v-else>已生效</span>
      </el-form-item>
      <el-form-item label="备注" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.introduce" placeholder="请输入备注" class="max-w460"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editOrder" :disabled="submit_loading">确 定</el-button>
    </div>
  </el-dialog>
  <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</Setlink>
  <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
</div>
</template>

<script>
  import AdvApi from '@/api/adv.js';
  import Setlink from '@/components/setlink/Setlink';
  import Upload from '@/components/file/Upload';
  export default {
    components: {
          Setlink,
          Upload,
      },
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*是否正在提交*/
        submit_loading: false,
        roleList:[],
        is_linkset: false,
        isupload: false,
      };
    },
    props: ['open_edit', 'form'],
    created() {
      console.log(this.form)
      this.dialogVisible = this.open_edit;
    },
    methods: {
      openUpload(e) {
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.adv_img = e[0].file_path;
      }
      this.isupload = false;
    },
     /*选择链接*/
     changeLink() {
            this.is_linkset = true;
        },

      /*获取链接并关闭弹窗*/
        closeLinkset(e) {
          this.is_linkset = false
          if (e) {
            this.form.adv_link = e.url
          }
        },
      /*修改用户*/
      editOrder() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.submit_loading = true;

            AdvApi.editOrder(params, true)
              .then(data => {
                self.submit_loading = false;
                self.$message({
                  message: '修改成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);

              })
              .catch(error => {
                self.submit_loading = false;
              });

          }
        });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/adv/order/Edit.vue